import { GET } from './NetService';

const Action = "area/";

export async function loadAll(bsignal)
{
    return await GET(Action,bsignal);
}

export async function GetAreasConsumo(bsignal)
{
    return await GET(Action + "consumo",bsignal);
}

export async function GetAreasPaciente(bsignal)
{
    return await GET(Action + "pacientes",bsignal);
}